import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	StaffSimpleDetail,
	StaffSimpleDetailDto,
	StaffSimpleDTO,
	StaffSimpleFilter,
} from '../DTO/user-management/userManagementList.interface';

export const userManagementListApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getUserList: builder.query<
			SuccessResponse<Paginated<StaffSimpleDTO>>,
			StaffSimpleFilter
		>({
			query: (body) => ({
				url: `/web/staffs/page`,
				method: 'POST',
				body,
			}),
		}),
		createUserList: builder.mutation<
			SuccessResponse<any>,
			StaffSimpleDetailDto
		>({
			query: (body) => ({
				url: `/web/staffs`,
				method: 'POST',
				body,
			}),
		}),
		deleteUser: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/staffs/${id}`,
				method: 'DELETE',
			}),
		}),
		getUserDetail: builder.query<SuccessResponse<StaffSimpleDetail>, string>({
			query: (id) => ({
				url: `/web/staffs/${id}`,
				method: 'GET',
			}),
		}),
		editUser: builder.mutation<SuccessResponse<any>, StaffSimpleDetailDto>({
			query: (body) => ({
				url: `/web/staffs`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['GetMe'],
		}),
	}),
});

export const {
	useGetUserListQuery,
	useCreateUserListMutation,
	useDeleteUserMutation,
	useGetUserDetailQuery,
	useEditUserMutation,
} = userManagementListApiSlice;
